// import libraries
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { useTranslation } from "react-i18next";
import axios from "axios";
// import files
import { env } from "../../env";
// import components
import Layout from "../../layouts/Layout";
import ProfileLayout from "../../components/Profile/ProfileLayout";
import LoaderIcon from "../../components/Common/Icon/Loader";
import SchedulePopUp from "../../components/Profile/SchedulePopUp";
import WarningPopUp from "../../components/Profile/WarningPopUp";
import AppointmentComponent from "../../components/Profile/AppointmentComponent";

const AppointmentIndex = () => {
    // variables
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();
    const baseUrl = env.REACT_APP_API_URL;
    const token = localStorage.getItem('token');
    // boolean
    const [isLoader, setIsLoader] = useState(true);
    const [showSchedulePopUp, setShowSchedulePopUp] = useState(false);
    const [showWarningPopUp, setShowWarningPopUp] = useState(false);
    // list data
    const [visitTypeList, setVisitTypeList] = useState([]);
    // data
    const [visitTypeData, setVisitTypeData] = useState({});
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [ipData, setIpData] = useState({});
    const [appointmentList, setAppointmentList] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            await getStateCityListApi(baseUrl, token);
            await getVisitTypeListApi(baseUrl, token);
            await getCustomerAppointmentsApi(baseUrl, token);

        };
        fetchData();
    }, [baseUrl, token]);

    const handlePageChange = (e, link) => {
        e.preventDefault();
        navigate(link);
    };

    // api's
    const getVisitTypeListApi = async(url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/OfflineSync/GetCustomerVisitType`,{ headers })
        .then((response) => {
            setVisitTypeList(response.data);
            getIpJson();
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getIpJson = async () => {
        try {
            const response = await axios.get("https://ipapi.co/json/", {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                },
            });
            setIpData(response.data);
        } catch (error) {
            console.error("Error fetching IP data:", error);
        }
    };
    const getStateCityListApi = async(url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Customer/GetUserAppointmentFilter`,{ headers })
        .then((response) => {
            setStateList(response.data.statelist);
            setCityList(response.data.citylist)
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getCustomerAppointmentsApi = async(url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/ClientAppointments/GetCustomerAppointments`,{ headers })
        .then((response) => {
            const formattedAppointments = processAppointments(response.data);
            setAppointmentList(formattedAppointments);
            setIsLoader(false);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const processAppointments = (data) => {
        return data.map(appointment => {
            // Construct start and end times
            const start = `${appointment.appointmentdate}T${appointment.appointmentfromtime}`;
            const end = `${appointment.appointmentdate}T${appointment.appointmenttotime}`;
            const geocode = [appointment.latGPS, appointment.longGPS];
            
            // Determine status and colors
            let status, borderColor, backgroundColor;
    
            if (appointment.iscomplete) {
                status = "completed";
                borderColor = 'border-cal-dblue';
                backgroundColor = 'bg-cal-lblue';
            } else if (appointment.iscancel) {
                status = "cancelled";
                borderColor = 'border-cal-dpink';
                backgroundColor = 'bg-cal-lpink';
            } else {
                status = "pending";
                borderColor = 'border-cal-dorange';
                backgroundColor = 'bg-cal-lorange';
            }
    
            return {
                ...appointment,
                start,
                end,
                geocode,
                status,
                borderColor,
                backgroundColor
            };
        });
    };
    
    // handle functions
    const handleOpenSchedulePopUp = (data) => {
        if(data === 'start') {
            setShowSchedulePopUp(!showSchedulePopUp)
        } else {
            setVisitTypeData({});
        }
    };
    const handleVisitResponseDataFromChild = (data) => {
        setVisitTypeData(data);
        setShowSchedulePopUp(!showSchedulePopUp);
    };
    const handleWarningPopUpDataFromChild = (data) => {
        setShowWarningPopUp(!showWarningPopUp);
        if(data === 'complete') {
            setVisitTypeData({});
        }
    };

    return (
        <div className="relative">
            <Layout>
                <div className="relative">
                    <ProfileLayout page={"schedule-visit"} customerData={{}} visitTypeData={visitTypeData} sendOpenSchedulePopUp={handleOpenSchedulePopUp} sendPageChange={handlePageChange} />
                    { isLoader
                        ?
                            <LoaderIcon />
                        :
                        <div className="space-y-2 sm:space-y-4">
                            <AppointmentComponent stateList={stateList} cityList={cityList} appointmentList={appointmentList} />
                        </div>
                    }
                </div>
            </Layout>
            {/* common */}
            {showSchedulePopUp && <SchedulePopUp customerId={id} ipData={ipData} visitTypeList={visitTypeList} sendSchedulePopUpDataFromChild={handleOpenSchedulePopUp} sendVisitResponseDataFromChild={handleVisitResponseDataFromChild} />}
            {showWarningPopUp && <WarningPopUp customerId={id} visitTypeData={visitTypeData} sendWarningPopUpDataFromChild={handleWarningPopUpDataFromChild} /> }
        </div>
    )
}

export default AppointmentIndex;